import { NgModule } from '@angular/core';
import { SanitizePipe } from './sanitize.pipe';

/** @deprecated - this is moved to libs */
@NgModule({
    exports: [
        SanitizePipe,
    ],
    declarations: [
        SanitizePipe,
    ],
})

export class SanitizePipeModule { }
